import type {Role} from '@/values/Role'
import {type GuidType} from '../../../values/generic-type-definitions'
import LoadingState from '../../../values/loading-state-enum'

export interface UsersReduxState {
    loadingState: LoadingState
    users: User[]
}

export interface User {
    user: GuidType
    username: string
    email: string
    emailNotificationEnabled: boolean
    active: boolean
    deleted: boolean
    roles: Role[]
    internalUser: boolean
    external: boolean
    assignedTag: GuidType | undefined
    strictMode: StrictMode | undefined
    notificationEmail: string | undefined
}

export const DEFAULT_USERS_STATE: UsersReduxState = {
    loadingState: LoadingState.NotPopulated,
    users: [],
}

export enum StrictMode {
    Strict = 'STRICT',
    DefaultVisibility = 'DEFAULT_VISIBILITY',
}
